var render = function render(){var _vm=this,_c=_vm._self._c;return _c('drag-modal',{attrs:{"visible":_vm.visible,"title":this.$store.state.dislog.editFileURL.file_name,"width":_vm.modalWidth,"zIndex":10003},on:{"cancel":_vm.close}},[_c('div',{attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }